import React, { useEffect, useRef, useState } from 'react';
import style from './MoreButton.module.css';

let currentOpenMenu = null;

const MoreButton = ({
  icon,
  children,
  profileImg,
  width,
  imgWidth,
  imgHeight,
  top,
  right,
  left,
  className,
  showStatus = false,
  setShowStatus,
}) => {
  const [showMenu, setShowMenu] = useState(false);
  const menuRef = useRef(null);

  const handleShowMenu = () => {
    if (currentOpenMenu && currentOpenMenu !== menuRef.current) {
      currentOpenMenu.closeMenu();
    }

    const newStatus = !showMenu;
    setShowMenu(newStatus);
    if (setShowStatus) {
      setShowStatus(newStatus);
    }

    if (newStatus) {
      currentOpenMenu = {
        ref: menuRef.current,
        closeMenu: () => setShowMenu(false),
      };
    } else {
      currentOpenMenu = null;
    }
  };

  const handleDocumentClick = (e) => {
    if (menuRef.current && !menuRef.current.contains(e.target)) {
      setShowMenu(false);
      if (setShowStatus) {
        setShowStatus(false);
      }
      currentOpenMenu = null;
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick);
    return () => {
      document.removeEventListener('click', handleDocumentClick);
    };
  }, []);

  return (
    <div className={`${style['parent']} ${className}`} ref={menuRef}>
      <div className={style['parent-sub']}>
        <img
          alt={'ph'}
          src={icon}
          className={profileImg ? style[profileImg] : style['more-img']}
          style={{ width: imgWidth, height: imgHeight }}
          onClick={(e) => {
            handleShowMenu();
            e.stopPropagation();
          }}
        />
        {showMenu && (
          <div
            className={
              profileImg ? style['profile-container'] : style['menu-container']
            }
            style={{ width, top, right, left }}
          >
            {children}
          </div>
        )}
      </div>
    </div>
  );
};

export default MoreButton;
